<template>
  <b-modal :active.sync="localContinueReadingEbookModal" :width="640" scroll="keep">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Continue Reading
        </p>
        <a class="card-header-icon" @click="closeModal()">
          <span class="icon is-small">
          <i class="mdi mdi-close"></i>
          </span>
        </a>
      </header>
      <single-ebook-card-content/>
      <footer class="modal-card-foot">
        <button type="button" v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-primary" @click="sendSection()">
          <span class="icon">
            <i class="mdi mdi-email"></i>
          </span>
          <span>Send Email</span>
        </button>
        <button v-if="internalEbook.amazonAffiliateUrl" class="button is-secondary" @click="clickOnAmazonLink()">
          <span>Learn More</span>
        </button>
        <button class="button" @click="closeModal()">
          Cancel
        </button>
      </footer>
      <b-loading :is-full-page="false" :active.sync="isLocalLoading" :can-cancel="false"></b-loading>
    </div>
  </b-modal>
</template>

<script>
import singleEbookCardContent from '@/components/single-ebook-card-content'

export default {
  name: 'continueReadingEbookModal',
  data () {
    return {
      localContinueReadingEbookModal: false,
      internalEbook: {}
    }
  },
  watch: {
    continueReadingEbookModal (value) {
      this.localContinueReadingEbookModal = value
    },
    getEbook (value) {
      this.internalEbook = value
    },
    localContinueReadingEbookModal (value) {
      if (!value) {
        this.$store.dispatch('closeContinueReadingEbookModal')
      }
    }
  },
  methods: {
    clickOnAmazonLink () {
      this.$store.dispatch('updateEbookOnAmazonLinkClick')
    },
    closeModal () {
      this.$store.dispatch('closeContinueReadingEbookModal')
    },
    sendSection () {
      const user = this.isAuthenticated
      if (user) {
        this.$store.dispatch('reSendChapterFromEbookModal', { ebookId: this.internalEbook.id, sectionId: this.internalEbook.sectionId, user: user.id })
      }
    }
  },
  computed: {
    getEbook () {
      return this.$store.getters.getEbook
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'continueReadingEbookModal' && localLoading.active
    },
    continueReadingEbookModal () {
      return this.$store.getters.isContinueReadingEbookModal
    }
  },
  components: {
    singleEbookCardContent
  }
}
</script>

<style>

</style>
